@if (variant() === 'mosaic') {
  @if (photos().length > 0) {
    <div
      class="relative rounded-3xl overflow-hidden bg-gray-2 border border-gray-6/80 shadow-sm grid grid-cols-1 md:grid-cols-4 gap-2 p-2 aspect-[16/10] md:aspect-[21/9] w-full"
    >
      <!-- Main Large Photo (Left 2 or 3 cols) -->
      <div
        class="relative h-full overflow-hidden rounded-2xl cursor-pointer group md:col-span-2 lg:col-span-3"
        (click)="openCarousel(0)"
        (keydown.enter)="openCarousel(0)"
        tabindex="0"
        role="button"
        aria-label="Agrandir la photo principale"
      >
        <img
          [src]="mainPhoto()?.url"
          [alt]="propertyTitle()"
          class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>

      <!-- Secondary Thumbnails (Right 1 or 2 cols) -->
      <div class="hidden md:grid grid-cols-1 md:grid-cols-2 gap-2 h-full lg:col-span-1">
        @for (photo of secondaryPhotos().slice(0, 4); track photo.file || $index; let i = $index) {
          <div
            class="relative h-full min-h-[90px] overflow-hidden rounded-xl cursor-pointer group bg-gray-3"
            (click)="openCarousel(i + 1)"
            (keydown.enter)="openCarousel(i + 1)"
            tabindex="0"
            role="button"
            [attr.aria-label]="'Agrandir la photo ' + (i + 2)"
          >
            <img
              [src]="photo.url"
              [alt]="'Photo ' + (i + 2)"
              class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          </div>
        }
      </div>

      <!-- Floating Button: See all photos -->
      <button
        type="button"
        (click)="openCarousel(0)"
        class="absolute bottom-4 right-4 bg-white/90 dark:bg-gray-1/90 hover:bg-white text-gray-12 backdrop-blur-md px-4 py-2 rounded-xl text-xs font-bold flex items-center gap-2 shadow-lg border border-gray-6 transition-all hover:scale-105 cursor-pointer z-10"
      >
        <mat-icon class="text-sm! w-4! h-4! text-indigo-9">photo_library</mat-icon>
        <span>Voir les {{ photos().length }} photos</span>
      </button>
    </div>
  } @else {
    <!-- Empty Photo State -->
    <div
      class="rounded-3xl border border-dashed border-gray-6 bg-gray-1/60 p-12 flex flex-col items-center justify-center text-center gap-3 text-gray-11"
    >
      <mat-icon class="text-5xl! w-14! h-14! text-gray-9">add_a_photo</mat-icon>
      <p class="text-base font-semibold m-0 text-gray-12">Aucune photo ajoutée pour le moment</p>
      @if (isOwner() && propertyId()) {
        <a mat-flat-button class="primary mt-2" [routerLink]="['/properties', propertyId(), 'edit']">
          Ajouter des photos
        </a>
      }
    </div>
  }
} @else {
  <!-- Grid layout (Standard / card view) -->
  <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
    @let photoList = photos();
    @for (photo of photoList; track photo.file || $index; let i = $index) {
      <div class="flex flex-col gap-3 group" [class.col-span-2]="i === 0" [class.row-span-2]="i === 0">
        <div
          class="rounded-2xl overflow-hidden bg-gray-2 shadow-sm relative transition-all duration-300 cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary focus:ring-inset"
          (click)="openCarousel(i)"
          (keydown.enter)="openCarousel(i)"
          (keydown.space)="openCarousel(i); $event.preventDefault()"
          tabindex="0"
          role="button"
          [class.flex-1]="i === 0"
          [class.aspect-[4/3]]="i !== 0"
        >
          <img
            [src]="photo.url"
            [alt]="'Photo ' + (i + 1)"
            class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />

          @if (i === 0) {
            <div class="absolute top-3 left-3 z-10">
              <div
                class="bg-brand-9 text-white text-[10px] font-bold uppercase py-1 px-2.5 rounded-full shadow-lg flex items-center gap-1.5 backdrop-blur-md"
              >
                <mat-icon class="w-3! h-3! text-[12px]! leading-none">star</mat-icon>
                <span>Couverture</span>
              </div>
            </div>
          }

          @if (
            photo.isHiddenBeforeMandate ||
            (photo.characteristicRef && photo.characteristicRef.section !== 'interior')
          ) {
            <div class="absolute top-3 right-3 z-10">
              <div
                class="bg-amber-9 text-amber-contrast text-[10px] font-bold py-1 px-2.5 rounded-full shadow-lg flex items-center gap-1 backdrop-blur-md"
                matTooltip="Photo protégée : visible par l'agent uniquement après la première visite"
              >
                <mat-icon class="w-3! h-3! text-[12px]! leading-none">lock</mat-icon>
                <span>Visite requise</span>
              </div>
            </div>
          }

          <!-- Photo Numbering -->
          <div class="absolute bottom-4 right-4">
            <div
              class="bg-black/50 text-white text-[10px] font-bold px-3 py-1.5 rounded-full backdrop-blur-md border border-white/10 shadow-sm"
            >
              {{ i + 1 }} / {{ photoList.length }}
            </div>
          </div>
        </div>

        <div class="px-1">
          <h3 class="text-base font-semibold text-gray-12 m-0 leading-tight truncate">
            {{
              photo.characteristicRef
                | etxeEnumDisplay: 'characteristicCategory' : property()?.characteristics
            }}
          </h3>
        </div>
      </div>
    } @empty {
      <div
        class="col-span-full py-12 bg-gray-2 border border-dashed border-gray-5 rounded-2xl flex flex-col items-center justify-center text-gray-10"
      >
        <mat-icon class="w-12 h-12 text-[48px] mb-3 opacity-30">photo_library</mat-icon>
        <p class="text-base font-medium">Aucune photo ajoutée</p>
      </div>
    }
  </div>
}
